module.exports = {
  services: {
    server:
      process.env.NODE_ENV === "production"
        ? "https://workstats.springup.app"
        : "https://workstats.springup.app",
  },
};
